<app-view-title [showHeader]="false" [isSplitColor]="true"></app-view-title>
<view-content [centered] ="true" [fullscreen]="true">
    @if(loading) {
    <app-loading-screen [centered]="true" title="{{ 'Intellitrailer.Rental.Start.StartingRental' | translate : 'Starting rental' }}" description="{{ 'Intellitrailer.Rental.Start.StartingRental2' | translate : 'This will just take a moment' }}"></app-loading-screen>
    }
    @else {
      <h2>{{ 'Intellitrailer.Rental.Start.Failed' | translate : 'Could not start rental' }}</h2>
        <p>{{ 'Intellitrailer.Rental.Start.msgErrorCode' | translate : 'Error code' }}:  <b>{{ errorCode }}</b></p>
        <img src="/Images/ErrorImg.png" />

        <!-- Wrong Stauts -->
        @if(errorCode == '10' || errorCode == '1')
        {
          <p>{{ 'Intellitrailer.Rental.Start.Error10Message1' | translate : 'The booking cannot be started. It may have already been started, or there might be an issue with the booking details.' }}</p>
          <br />
          <p>{{ 'Intellitrailer.Rental.Start.Error10Message2' | translate : 'Please check and try again.' }}</p>
          <button mat-raised-button (click)="goTo('MyBookings')">
            {{ 'Intellitrailer.Rental.Start.btnActionError10' | translate : 'Go back' }}
            <mat-icon>undo</mat-icon>
          </button>
        }
        <!-- No rental object found -->
        @if(errorCode == '9') {
          <p>{{ 'Intellitrailer.Rental.Start.Error9Message1' | translate : 'The booking cannot be started. A trailer is not assigned to this booking, or there might be an issue with the booking details.' }}</p>
          <br />
          <p>{{ 'Intellitrailer.Rental.Start.Error9Message2' | translate : 'Please check and try again or contact support for assistance.' }}</p>
          <button mat-raised-button (click)="goTo('MyBookings')">
            {{ 'Intellitrailer.Rental.Start.btnActionError9' | translate : 'Go back' }}
            <mat-icon>undo</mat-icon>
          </button>
        }

        <!-- No rental found -->
        @if(errorCode == '8') {
          <p>{{ 'Intellitrailer.Rental.Start.Error8Message1' | translate : 'The booking cannot be started. We couldn’t find the booking, or there might be an issue with the booking details.' }}</p>
          <br />
          <p>{{ 'Intellitrailer.Rental.Start.Error8Message2' | translate : 'Please check and try again.' }}</p>
          <button mat-raised-button (click)="goTo('MyBookings')">
            {{ 'Intellitrailer.Rental.Start.btnActionError8' | translate : 'Go back' }}
            <mat-icon>undo</mat-icon>
          </button>
        }
    }
</view-content>
